import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import * as Cookies from 'js-cookie';

/*
    by default Cookies.get decodes:
    Test+user+%2BTest%2Buser > Test+user++Test+user
    but it should be
    Test user +Test+user
 */
const cookies = Cookies.withConverter({
    read: function (value:string): string {
        return decodeURIComponent(value.replace(/\+/g, '%20'));
    }
})

@Options({
    template: false,
    ui: {
        loginBtn: "[data-js-ui=login-btn]",
        accountBtn: "[data-js-ui=account-btn]",
        accountMenu: "[data-js-ui=account-menu]",
        username: "[data-js-ui=account-username]",
        cart: "[data-js-ui=cart]",
        accountItem: "[data-js-ui=account-item]",
        countdown: "[data-js-ui=countdown]",
        countdownContainer: "[data-js-ui=countdown-container]",
        mobileAccountBtn: "[data-js-ui=mobile-account-btn]",
        mobileLogoutBtn: "[data-js-ui=mobile-logout-btn]",
        avatar: "[data-js-ui=avatar]",
    }
})

export default class LoginView extends Marionette.View<Backbone.Model>{

    config?: object;
    ticketCount: number;
    ticketExpirationTime: number;
    hideTimer: boolean;
    isLoggedIn: boolean
    basketCount: number
    ticketInterval: any

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};
        this.ticketCount = Number(Cookies.get("_bo_ticket_count"))
        this.ticketExpirationTime = Number(Cookies.get("_bo_ticket_expiration_time"))
        this.hideTimer = Cookies.get("_bo_hide_basket_timer") == "1";
        // Uncomment below to force countdown bar to show for 5 seconds
        // this.ticketExpirationTime = new Date().getTime() + 5000
        this.isLoggedIn = Cookies.get("_bo_logged_in") == "1"
        this.basketCount = Number(Cookies.get("_bo_basket_count")) || 0
    }

    onRender() {
        this.checkLoggedIn();
        this.updateCart()
        this.initCountdown()
    }

    initCountdown() {
        if (this.ticketExpirationTime && !this.hideTimer) {
            this.ui.countdownContainer.show()
            this.updateCountdown()
            this.ticketInterval = setInterval(() => this.updateCountdown(), 1000)
        }
    }

    updateCountdown() {
        let now = new Date()
        let future = new Date(this.ticketExpirationTime * 1000)
        let delta = future.getTime() - now.getTime()

        if (delta < 0) {
            clearInterval(this.ticketInterval)
            this.ui.countdownContainer.hide()
            return
        }
        let seconds = delta / 1000
        let minutes = seconds / 60
        let outMinutes = Math.floor(minutes)
        let outSeconds = Math.round(minutes % 1 * 60)

        let text = `${outMinutes} minutes, ${outSeconds} seconds remaining to complete purchase.`
        this.ui.countdown.text(text)
    }

    updateCart() {
        this.ui.cart.html(`
        <div class="cart__icon"></div>
        <div class="cart__mobile-link no-translate" data-auto-translate>CART</div>
        <div class="cart__item-count">
         (${this.basketCount}<span class="sr-only"> items</span>)
        </div>
         `)
    }

    checkLoggedIn() {
        const $body = $('body');
        const bodyClass = this.isLoggedIn ? 'is-logged-in' : 'is-logged-out';
        $body.addClass(bodyClass);
        this.ui.username.text(cookies.get("bo_first_name"));
        this.updateFacebookProfile();
    }

    updateFacebookProfile() {
        let facebookAppId = (<any>window).DJANGO.facebookAppId
        if (!facebookAppId) return
        $.ajaxSetup({ cache: true });
        $.getScript('https://connect.facebook.net/en_US/sdk.js', this.onFacebookScriptLoaded.bind(this));
    }

    onFacebookScriptLoaded() {
        let facebookAppId = (<any>window).DJANGO.facebookAppId
        FB.init({
            appId: facebookAppId,
            version: 'v2.7'
        });
        FB.getLoginStatus(this.onFacebookLoginStatusComplete.bind(this));
    }

    onFacebookLoginStatusComplete(resp) {
        if (resp.status == "connected") {
            FB.api('/me', { fields: 'id, name, email' }, this.updateFacebookUsersImage.bind(this));
        }
    }

    updateFacebookUsersImage(response) {
        let url = `https://graph.facebook.com/${response.id}/picture`
        this.ui.avatar.attr('src', url)
    }

}




// WEBPACK FOOTER //
// ./@modules/views/login-view.ts